import styled, { keyframes } from 'styled-components';

const float = keyframes`{
  0% {
    transform: translatey(0px) rotate(20deg);
  }
  50% {
    transform: translatey(-10px) rotate(20deg);
  }
  100% {
  transform: translatey(0px) rotate(20deg);
  }
}`;

export const AvatarsCollisionWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;

  .avatar_bubble {
    box-shadow: 0px 2px 6px 1px rgba(0, 0, 0, 0.16);
    transform: rotate(20deg);
    animation: ${float} 6s ease-in-out infinite;
  }
`;

export const AvatarCollisionBubble = styled.div`
  position: absolute;
  top: ${props => props.top}px;
  left: ${props => props.left}px;
  z-index: ${props => props.zIndex};
`;



// WEBPACK FOOTER //
// ./src/components/AvatarsCollision/components/styles.js